export const actions = {
  async uploadFile({commit}, dataForm){
      try {
          const data = await this.$repositories.lienHe.uploadFile(dataForm)
        return data
      } catch (e) {
        return e;
      }
  },
}